import { mxgraphInstance } from './mxgraphFactory';
/**
 * Model
 */
export var mxCell = mxgraphInstance.mxCell;
export var mxCellPath = mxgraphInstance.mxCellPath;
export var mxGeometry = mxgraphInstance.mxGeometry;
export var mxGraphModel = mxgraphInstance.mxGraphModel;
// /**
//  * mxGraphModel Change
//  */
// export const mxRootChange = mxgraphInstance.mxRootChange;
// export const mxChildChange = mxgraphInstance.mxChildChange;
// export const mxTerminalChange = mxgraphInstance.mxTerminalChange;
// export const mxValueChange = mxgraphInstance.mxValueChange;
// export const mxStyleChange = mxgraphInstance.mxStyleChange;
// export const mxGeometryChange = mxgraphInstance.mxGeometryChange;
// export const mxCollapseChange = mxgraphInstance.mxCollapseChange;
// export const mxVisibleChange = mxgraphInstance.mxVisibleChange;
// export const mxCellAttributeChange = mxgraphInstance.mxCellAttributeChange;
//# sourceMappingURL=Model.js.map